import { useMemo } from 'react';

import configJson from '@/config.json';
import { useMasterclass } from '@/contexts/MasterclassContext';

export const useIsAccreditationUser = (): boolean => {
  const { userProfile } = useMasterclass();

  return useMemo(() => {
    const userEmail = userProfile?.email;
    if (!userEmail) return false;
    return configJson.accreditationEmails.includes(userEmail);
  }, [userProfile]);
};
